var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnNoImg = function SvgIcnNoImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 10H10.5C8.84315 10 7.5 11.3431 7.5 13V28.5809V28.5812V33C7.5 34.6569 8.84315 36 10.5 36H31.1655C30.9134 35.3641 30.7279 34.6946 30.6178 34H10.5C9.94772 34 9.5 33.5523 9.5 33V28.9954L17.4997 20.9997L23.6942 27.1905L23.8202 27.3062C24.5126 27.8897 25.5215 27.9381 26.2702 27.4037L30.1417 24.6397L32.3576 26.856C32.7557 26.3177 33.2095 25.823 33.7102 25.3802L31.5561 23.2256L31.4301 23.1098C30.7377 22.5259 29.7284 22.4773 28.9796 23.0119L25.1081 25.7759L18.9142 19.5851L18.7869 19.4684C18.0006 18.8072 16.8265 18.8461 16.0864 19.5845L9.5 26.1677V13C9.5 12.4477 9.94772 12 10.5 12H36.5C37.0523 12 37.5 12.4477 37.5 13V23.3324C38.1422 23.1577 38.8114 23.0486 39.5 23.0129V13C39.5 11.3431 38.1569 10 36.5 10ZM32 20C33.3807 20 34.5 18.8807 34.5 17.5C34.5 16.1193 33.3807 15 32 15C30.6193 15 29.5 16.1193 29.5 17.5C29.5 18.8807 30.6193 20 32 20Z",
    fill: "#C6C8CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25C35.8525 25 32.5 28.3525 32.5 32.5C32.5 36.6475 35.8525 40 40 40C44.1475 40 47.5 36.6475 47.5 32.5C47.5 28.3525 44.1475 25 40 25ZM43.75 35.1925L42.6925 36.25L40 33.5575L37.3075 36.25L36.25 35.1925L38.9425 32.5L36.25 29.8075L37.3075 28.75L40 31.4425L42.6925 28.75L43.75 29.8075L41.0575 32.5L43.75 35.1925Z",
    fill: "#C6C8CC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnNoImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_noImg.52578b1f.svg";
export { ForwardRef as ReactComponent };